import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Grid, Modal } from "@mui/material";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import PageTitle from "../commoncomponents/PageTitle";
import PageLoader from "../commoncomponents/PageLoader";
import { useDispatch } from "react-redux";
import CustomDialog from "../commoncomponents/CustomDialog";
import { useNavigate } from "react-router-dom";
import { MasterGraph, FemsGraph, BemsGraph } from "../../utility/apiURLS";
import axios from 'axios';
import {
  getAuthToken,
  getFacilityId,
  getcompanyId,
} from "../../utility/tokenUtility";
import CustomTextFieldWithSearch from '../commoncomponents/CustomTextFieldWithSearch';
import commonMessages from "../../utility/constant";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import Qualitydownloadfile from "./Qualitydownloadfile";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "1200px",
  maxHeight: "calc(100% - 64px)",
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "5px",
  p: 4,
  overflowY: "auto",
};

const currentMonthIndex = new Date().getMonth();
const Qualityviewfile = () => {
  // const [year, setYear] = useState(null);
  // const [month, setMonth] = useState(null);
  const [text, setText] = useState("");
  const [date, setDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [department, setDepartment] = useState(null); // This should be the selected department object
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [departmentError, setDepartmentError] = useState("");
  const [isView, setIsView] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [reportdata, setReportdata] = useState('');
  const [report, setReport] = useState([]);
  const [service, setService] = useState({
    value: "FEMS",
    label: "FEMS",
    id: "2f702577-5b94-4975-9367-e1b3721f6e7a"
  });
  const [serviceOptions, setServiceOptions] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState({
    label: 'PPM',
    value: 1
  });
  const childRef = useRef(null);
  // const currentYear = new Date().getFullYear();

  const currentMonthIndex = new Date().getMonth(); // 0 = January, 11 = December
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);
  const [monthsOptions, setMonthsOptions] = useState([]);
  // const [monthsOptions, setMonthsOptions] = useState([]);

  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGA009");

  const allMonths = commonMessages.months;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = getAuthToken("id_token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const facilityId = localStorage.getItem('facilityId');

  const currentYear = new Date().getFullYear();
  const yearsOptions = Array.from(
    { length: currentYear - 2016 + 1 },
    (_, i) => ({
      label: (2016 + i).toString(),
      value: (2016 + i).toString(),
    })
  );

  useEffect(() => {
    setYear({ label: currentYear.toString(), value: currentYear.toString() });
    // setMonthsOptions(allMonths.slice(0, new Date().getMonth() + 1));
    setMonthsOptions(allMonths.slice(0, currentMonthIndex + 1));
    setMonth(allMonths[currentMonthIndex]);
    fetchServiceOptions();
  }, []);

  const fetchServiceOptions = async () => {
    try {
      const response = await axios.get(`${MasterGraph}/api/masservicedetails`, config);
      const options = response.data.map(option => ({
        label: option.service,
        value: option.service,
        id: option.id
      }));
      setServiceOptions(options);
    } catch (error) {
      console.error("Error fetching service options:", error);
    }
  };
  const handleCancelConfirm = () => {
    setCancelDialogOpen(false);
    navigate("/dashboard");
    dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
    dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
  };
  const handleServiceChange = (selectedOption) => {
    setService(selectedOption);
    setText("");
    setDate("");
  };

  const handleCancelDialogClose = () => {
    setCancelDialogOpen(false);
  };

  const handleYearChange = (newValue) => {
    if (newValue) {
      // Only update if the year is different from the current year
      if (newValue.value !== year?.value) {
        setYear(newValue);

        const selectedYear = parseInt(newValue.value);

        // If the selected year is the current year, limit months to the current month
        const months = selectedYear === currentYear
          ? allMonths.slice(0, currentMonthIndex + 1) // Show months up to the current month
          : allMonths; // Show full year for any other year

        // Set available months based on the selected year
        setMonthsOptions(months);

        // Auto-select the current month for the current year
        if (selectedYear === currentYear) {
          setMonth(months[currentMonthIndex]); // Automatically select the current month
        } else {
          // For non-current years, set the first month (January) or null if unavailable
          setMonth(months[0] || null);
        }
      }
    }
    setText("");
    setDate("");
  };
  const handleMonthChange = (newValue) => {
    setMonth(newValue);
    setText("");
    setDate("");

  };


  useEffect(() => {
  }, [monthsOptions]);

  const handleDepartmentChange = (selectedOption) => {
    if (selectedOption) {
      setDepartment(selectedOption); // Make sure to set the entire selected option object
      setDepartmentError(""); // Reset error message if needed
    } else {
      setDepartmentError("Invalid selection"); // Handle error
    }
    setText("");
    setDate("");



  };
  const handleReportChange = (selectedOption) => {

    setSelectedReport(selectedOption);
    setText("");
    setDate("");

  };

  const fetchOptions = async () => {
    try {
      const response = await axios.get(`${MasterGraph}/api/GraphUserDepartmentDetails/GetUserDepartmentDetailsByFacilityId/${facilityId}?page=1&size=10000`, config);
      const combinedData = [...response.data.items];

      const reArrangedData = combinedData.map((items) => ({
        label: `${items.departmentcode} - ${items.departmentdesc}`, // Display label
        value: items.departmentdesc,
        assetNo: items.departmentcode, // Keep department code for display
        id: items.id, // Include id for reference
        departmentcode: items.departmentcode, // Include department code
        departmentdesc: items.departmentdesc // Include department description
      }));

      setDepartmentOptions(reArrangedData); // Set department options here


    } catch (error) {
      console.error("Error fetching department details:", error);
    }
  };

  const fetchReportdata = async () => {
    setIsLoading(true);
    const reportValue = selectedReport.value;
    const departmentId = department && department.id ? department.id : "00000000-0000-0000-0000-000000000000";

    try {
      let response;
      if (service.value === "FEMS") {
        response = await axios.get(
          `${FemsGraph}/api/QualityImprovement/GetQualityPPMReportfem/${reportValue}/${year.value}/${month?.id}/${getFacilityId()}/${departmentId}?size=1000`,
          config
        );
      } else if (service.value === "BEMS") {
        response = await axios.get(
          `${BemsGraph}/api/QualityImprovement/GetQualityPPMReportbem/${selectedReport.value}/${year.value}/${month?.id}/${getFacilityId()}/${departmentId}?size=1000`,
          config
        );
      }

      const reportdata = Array.isArray(response.data) ? response.data[0] : response.data;
      setReportdata(reportdata);


    } catch (error) {
      console.log("Error fetching report data:", error);
    }
    finally {
      setIsLoading(false);
    }
  };
  const fetchReportgraphdata = async () => {
    const reportValue = selectedReport.value;
    const departmentId = department && department.id ? department.id : "00000000-0000-0000-0000-000000000000";

    try {
      let response;


      if (service.value === "FEMS") {
        response = await axios.get(
          `${FemsGraph}/api/QualityImprovement/GetQualityPPMReportGraphfem/${reportValue}/${year.value}/${month?.id}/${getFacilityId()}/${departmentId}?size=1000`,
          config
        );
      } else if (service.value === "BEMS") {
        response = await axios.get(
          `${BemsGraph}/api/QualityImprovement/GetQualityPPMReportGraphbem/${reportValue}/${year.value}/${month?.id}/${getFacilityId()}/${departmentId}?size=1000`,
          config
        );
      }
      const reportData = response.data;


      if (Array.isArray(reportData)) {
        setReport(reportData); // Set the array data
      } else {
        console.error("API response is not an array", reportData);

        setReport([]);
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
    }
  };

  useEffect(() => {
    fetchOptions();
    fetchReportdata();
    fetchReportgraphdata();
  }, []);
  const handleView = async () => {
    await fetchReportdata();
    await fetchReportgraphdata();
    setOpenModal(true);
    setIsView(true);
  };

  const handleDownload = async () => {
    await fetchReportgraphdata();
    await fetchReportdata();
    setIsView(false);
    setOpenModal(true);
    setTimeout(() => {
      if (childRef.current) {
        childRef.current.handleDownloadPDF();
      }

      setTimeout(() => {
        setOpenModal(false);
      }, 1000);
    }, 500);


  };
  const handleCancel = () => {
    if (!service) {
      navigate("/dashboard");
      dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
      dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
    }
    else {
      setCancelDialogOpen(true);
    }

  };
  return (
    <>
      <PageLoader open={false} />
      <PageTitle title="Quality Improvement Analysis" />
      <DefaultCard>
        <Grid container spacing={2}>
          <Grid item xs={6} md={4}>
            <CustomSelectInput
              label="Year"
              id="Year"
              options={yearsOptions}
              value={year}
              onChange={handleYearChange}
              disableClearable={true}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <CustomSelectInput
              label="Month"
              name="Month"
              options={monthsOptions}
              value={month}
              onChange={handleMonthChange}
              placeholder="Select Month"
              disabled={!year}
              disableClearable={true}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <CustomSelectInput
              label="Service"
              id="service-label"
              value={service}
              options={serviceOptions}
              onChange={handleServiceChange}
              isMandatoryField={true}
              disableClearable={true}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <CustomTextFieldWithSearch
              label="Department"
              name="Department"
              id="Department"
              value={department} // This should be the selected department object
              options={departmentOptions}  // Pass the options state here
              getOptionLabel={(option) => option.label} // Display department code and description
              isOptionEqualToValue={(option, value) => option.id === value.id} // Compare based on ID

              onChange={handleDepartmentChange} // Ensure this function handles the selected value
              error={!!departmentError}
              helperText={departmentError}
            />
            <br /><br /> {/* Adds extra spacing between the field and the note */}

            <label style={{ textWrap: "nowrap" }}>
              <strong>
                <span style={{ color: 'red' }}>*</span> Note: If 'Department' is not selected, it will show the whole hospital quality improvement report.
              </strong>
            </label>

          </Grid>
          <Grid item xs={6} md={4}>
            <CustomSelectInput
              label="Select Report"
              value={selectedReport}
              options={[
                { label: 'PPM', value: '1' },
                { label: 'Work Order', value: '2' }
              ]}
              onChange={handleReportChange}
              disableClearable={true}
            />
          </Grid>
        </Grid>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 3 }}>
          <Button variant='contained' onClick={handleView}>View</Button>
          {access?.canPrint && <Button variant='contained' onClick={handleDownload}>Download</Button>}
          <Button variant='outlined' onClick={handleCancel}>Close</Button>
        </Box>
      </DefaultCard>
      <Modal
        open={openModal}
        sx={
          !isView && {
            "& .MuiBackdrop-root": {
              backgroundColor: "transparent",
            },
            top: "-9999px",
            left: "-9999px",
            zIndex: "-1",
          }
        }
      >

        <Box sx={ModalStyle}>
          <Qualitydownloadfile
            ref={childRef}
            year={year?.label}
            month={month?.label}
            service={service?.label}
            department={department?.departmentdesc}
            reportdata={reportdata}
            report={report}
            selectedReport={selectedReport}
            setOpenModal={setOpenModal}
            setIsView={setIsView}
            text={text}
            setText={setText}
            date={date}
            setDate={setDate}
          />
         
        </Box>
      </Modal>
      <CustomDialog
        open={cancelDialogOpen}
        onClose={handleCancelDialogClose}
        onConfirm={handleCancelConfirm}
        title="Cancel Confirmation"
        content="Do you want to continue?"
        cancelBtn="No"
        confirmBtn="Yes"
      />

    </>
  );
};

export default Qualityviewfile;
